module.exports =  {
  hotel: {
    BOOKING_NOW: 'Book Now',
    Book_Hotel: 'Accommodations',
    Select_your_destination: 'Select your destination',
    Please_enter_your_destination: 'Please enter your destination/hotel',
    Booked_up: 'Booked up',
    Hotel_description: 'Hotel description',
    Check_in_date: 'Check-in date',
    Check_out_date: 'Check-out date',
    Sold_out: 'Sold out',
    Non_refundable: 'Non-refundable',
    reserve: 'Book',
    Pay_Online: 'Pay Online',
    Only_rooms_left_before: 'Only',
    Only_rooms_left_after: 'room(s) left',
    Cancellation_Policy: 'Cancellation Policy',
    See_all_prices_before: 'See all ',
    See_all_prices_after: 'prices',
    Estimated_time_of_arrival: 'Estimated time of arrival',
    make_your_schedule_well_planned: 'Time is for local time zone, please make your schedule well-planned and arrive on time.',
    Hotel_Not_Found: 'Hotel Not Found',
    Please_change_your_search: 'Please change your search',
    Submit_an_application: 'Submit an application',
    Hotel_Confirmation: 'Hotel Confirmation',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-Night Stay',
    Hotel_Booking_Number: 'Hotel Booking Number',
    Online_Payment: 'Online Payment',
    The_guest_Room_before: 'The guest',
    The_guest_Room_after: ']',
    Contact_number: 'contact number',
    Bring_all_valid_IDs: 'Please bring all valid IDs of all guests when checking in.',
    Hotels_Found_before: '',
    Hotels_Found_after: 'Hotels Found',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'Hotels Presented (',
    Hotels_Presented_after: ' in total)',
    Please_change_the_dates: 'Room not available on your dates, please change the dates.',
    Login: 'Log in on the APP to book hotel',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Night(s)',
    Location: 'Location',
    Pictures: 'Pictures',
    Description: 'Description',
    Policy: 'Policy',
    Check_in_and_check_out_time: 'Check- in and check-out time',
    Check_in_and_Check_out_before: 'Check-in: after ',
    Check_in_and_Check_out_center: 'Check-out: before ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'Check-in',
    Check_out_time: 'Check-out',
    Facility_Service: 'Facility & Service',
    Payment_methods: 'Payment methods accepted by the hotel',
    Hotel_Address: 'Hotel Address',
    Pay_online: 'Pay online',
    Pay_offline: 'Pay offline',
    Night_stay_before: '',
    Night_stay_after: '-Night Stay,',
    Rooms_total_before: 'Rooms',
    Rooms_total_after: 'in total',
    Guest_name_must_be_provided: 'The full guest name must be provided.',
    Please_fill_in_your_contact_number: 'Please fill in your contact number',
    Select_estimated_time_of_arrival: 'Select estimated time of arrival',
    Number_of_Rooms: 'Number of Rooms',
    Maximum_guests_per_room_before: 'Maximum ',
    Maximum_guests_per_room_after: ' guests per room',
    Many_Rooms: ' Rooms',
    Service_Fee_Included: '(Tax & Service Fee Included)',
    Last_Name: 'Last Name',
    First_Name: 'First Name ',
    Room: 'Room',
    Additional_Tax: 'Additional Tax ',
    Please_inform_the_hotel: 'If you were to arrive beyond estimated arrival time, please inform the hotel in advance.',
    Please_inform_the_hotel_first: 'Arrival at the hotel beyond the estimated arrival time without contacting the hotel in advance will affect the availablity of the room and dinner. Please inform the hotel first to confirm the availablity in such circumstance.',
    Booking_Cancellation: 'Booking Cancellation',
    Reason_of_Cancellation: 'Reason of Cancellation',
    Incorrect_Information_Filled: 'Incorrect Information Filled',
    Itinerary_Changed: 'Itinerary Changed',
    Lower_price_on_other_APP: 'Lower price on other APP',
    Low_quality_hotel: 'Low-quality hotel',
    Book_at_a_lower_price: 'Book at a lower price at the front desk',
    Other: 'Other',
    Please_write_your_reason: 'Please write your reason',
    After_cancellation_done: 'After cancellation done, the payment will be returned to the original payer within 3 working days.',
    How_to_fill_in_the_guest_name: 'How to fill in the guest name',
    It_should_be_exactly_the_same: 'Please provide the guest name in English letters for hotel reservation. It should be exactly the same as the certificate presented when you check in.',
    How_to_fill_in_a_Chinese_name: 'How to fill in a Chinese name:',
    How_to_fill_in_a_English_name: 'How to fill in an English name',
    For_example: 'For example: If your Chinese name is “韩梅梅”, the last name is "Han", the first name is "Meimei".',
    No_specical_characters: 'Do not fill in any numbers or specical characters. ',
    Name_rule_first: 'The last name comes first, the first name follows, and if there is a middle name, it is followed by a space behind the two names. ',
    Name_rule_second: 'For example: Green / Jim Stephanie',
    Details: 'Details',
    Pay_now: 'Pay now',
    Hotel: 'Hotel',
    Check_in: 'Check  in',
    Car: 'Car',
    All_bookings: 'All bookings',
    All: 'All',
    the_real_scene: 'Pictures are for reference only and subject to the real scene.',
    COUPON_TXT: 'Coupon',
    SHEET: '',
    NONE_USE_TEXT: 'No applicable coupon',
    USE_COUPON: 'Redeem Coupon',
    BINDING_COUPON: 'Bind Coupon',
    DESELECT_COUPON: 'Deselect coupon',
    AVAILABLE: 'Available',
    NO_COUPON_AVALIABLE: 'No coupon available.',
    UNAVAILABLE: 'Unavailable',
    NOT_ACTIVE: 'Not Active',
    COUPON_TO_BINDING: 'Bind coupon',
    WRITE_PREFERETIAL_CODE: 'Please enter promotion code',
    BINDING_USE: 'Bind and Use',
    HAS_DEDUCTED_BEFORE: '',
    HAS_DEDUCTED_AFTER: 'deducted',

    NAME_TXT: 'Name',
    HOLDER_NAME: 'Card Holder Name',
    EXPIRATION_DATE: 'Expiration Date',
    FORMAT_TXT: 'Format',
    SECURITY_CODE: 'Security Code',
    MASTER_CARD_NAME: 'Master Card',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: 'The 3 digits on the back of the card.',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '4 digits on the front of card',
    ENTER_COMPLETE_CARD_NUM: 'Please enter a complete card number.',
    PLEASE_ENTER_HOLDER_NAME: 'Enter card holder name',
    ENTER_SECURITY_CODE: 'Enter security code',
    ENTER_EXPIRATION_DATE: 'Enter expiration date',
    ROOM_DETAILS: 'Room Details',
    CONDITION_CANCEL: 'Refundable',
    CHOOSE_PAYMENT_METHOD: 'Payment',
    ORDER_TOTAL_LUMP: 'Total Amount',
    CREDIT_CARD_NUM: 'Debit / Credit Card Number',
    MAINLAND_CARD_ONLY: 'Bank card issued outside Mainland China only.',
    SHUT_DOWN: 'Close',
    SELECT_COUNTRY_CODE: 'Select country or region',
    HOT_COUNTRY_OR_AREA: 'Most-selected',
    EVAL_LIST_NO_DATA: 'No data now',


    // 酒店搜索改版新增翻译
    PREFIX_ROOMS: '',
    SUFFIX_ROOM: 'Room',       // 单数
    SUFFIX_ROOMS: 'Rooms',     // 复数
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'Adult',
    SUFFIX_ADULTS: 'Adults',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'Child',
    SUFFIX_CHILDREN: 'Children',
    ROOM: 'Room',
    AGE: 'year old',
    AGES: 'years old',
    SELECT_ROOMS_TIPS: 'Please include each Child\'s age so we can find you the best room and bed configuration.',
    CHECK_IN_DETAIL: 'Guest details',
    CHILD_AGE: 'Child\'s Age',
    FILTER_CONDITION: 'Your Selection:',
    NO_MATCH_TIPS: 'The below room type does not match the number of rooms and guests you selected.',
    ROOM_COUNT: 'Rooms',
    GUESTS: 'Guests',
    NO_MATCH_HOTEL: 'Below are hotels that do not match your selections.',
    TAXES_INCL: 'Taxes incl.',
    BOOK_TIMEOUT_TIPS: 'Page expired. Please return to the hotel details page and refresh. Prices and avaliability are subject to change during the period.',
    LIST: 'List',
    RENT_CAR_BOOK: 'Reservation',
    HOTEL_STR: 'Details',
    SETTLEMENT_DETAIL: 'Guest Details',
    CONTACT_NAME: 'Contact Person',
    COUNTRY_CODE: 'Area code',
    PHONE_NUMBER: 'Phone number',
    TRAVEL_PHONE_NUMBER: 'Enter contact name',
    PLEASE_SELECT_AREA_CODE: 'Please select an area code.',
    PERSON_COUNT: 'Guests',

    Search: 'Search',
    COST_DESCRIPTION: 'Price Detail',
    TOTAL: 'Total',
    SEE_ORDER_INFO_TO: 'Pay',
    KONW: 'Got it',
    BOOKING_INFORMATION: 'Important Information',
    Book_Now: 'Pay It Now',
    MAP: 'Map',
    CONTACT_INFORMATION: 'Contact Information',
    LOADING: 'Loading...',
    SORT_FILTER: 'Sort/Filter',
    SCREENING: 'Filter',
    SEQUENCE: 'Sort',
    PHONE_ASK: 'Call us',
    ABOVE: '',
    SUBMINT_ORDER: 'Submit',
    OK: 'OK',
    Order_detail: 'Order details',
    BOOKING_INFO: 'Booking Info',
    PAYMENT_AMOUNT: 'Payment Amount',
    Order_time: 'Booking Time',
    ORDER_NUMBERS: 'Booking No',
    PAY_TYPE: 'Payment Method',
    BALANCE: 'Balance',
    CURRENT_BALANCE_BEGIN: 'Balance',
    OVERPLUS_BALANCE_BEGIN: 'Remaining',
    OTHER_PAYMENT: 'Other payment methods',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat Payment',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'Click on “Pay It Now” Means You Agree Upon Baigolf ',
    AGREE_SERVICE_AGREEMENT_AFTER: '',
    SERVICE_AGREEMENT: '《Service Agreement》',
    PAYMENT_ORDER: 'Booking Payment',
    Total_pay: 'Amount Due',
    PAY_SUCCESS: 'Payment Accepted',
    CHECK_THE_ORDER: 'Check the Order',
    BACK_TO_INDEX: 'Back to Index',
    CANCEL: 'Cancel',
    RECOMMED: 'Recommend',
    PRICE: 'Price',
    HIGH: 'High',
    LOW: 'Low',
    RESET: 'Reset',
    SELECT_TIME: 'Select Date',
    Hotel_guest: 'The guest',
    Select: 'Please Select',
    Emial_address: 'Please enter email address',
    Booking_explan: 'Booking Information',
    VIEW_MORE: 'View more',
    COLLAPSE: 'Hide',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'Check in',
    TOURISM_LEAVE_HOTEL: 'Check out',
    SUBMIT: 'Submit',
    EMAIL: 'Email',
    BOOK_FAIL: 'Booking failed',
    BOOK_FAIL_DETAIL: 'Oops...your booking is failed, please try again.',
    RESET_BOOK: 'Book again',
    ROOM_TYPE_LOADING_TIPS: 'Searching for rooms and prices, please wait...',
    NEARBY_HOTEL: 'Nearby Hotels',
    HOT_CITY: 'Hot destinations',

    SEARCH_HISTORY: 'Search History',
    BREAKFAST_INCLUDE: 'breakfast include',
    BREAKFAST_EXCLUDE: 'breakfast exclude',
    DOUBLE_BED: 'double bed',
    TWIN_BED: 'twin bed',
    FREE_CANCEL: 'free cancellation',
    MEALS: 'meals',
    EVALUATION: 'Review',
    FEATURED_REVIEWS: 'Featured Reviews',
    ALL_REVIEWS: 'All Reviews',
    OVERALL_EVALUATION: 'Overall Review',
    ANONYMOUS: 'Anonymous',
    EVAL_GENERAL_LIST_1: 'Poor',
    EVAL_GENERAL_LIST_2: 'Fair',
    EVAL_GENERAL_LIST_3: 'Average',
    EVAL_GENERAL_LIST_4: 'Good',
    EVAL_GENERAL_LIST_5: 'Excellent',
    MAX_IMAGES_WITH_NINE: 'A maximum of 9 pictures can be selected.',
    GRADE_EVAL: 'Please select Overall Rating',
    DISTANCE_FILTER: 'distance close-far',
    EDIT_EVALUATION: 'give comments',
    GO_TO_EVAL: 'give comments',
    EVAL_POINTS_AWARD: 'Good comments can win 1000points,1000 points=10RMB',
    NEARBY_LIKE_HOTEL: 'similar hotel nearby',
    DISTANCE_HOTEL: 'to hotel',
    PLEASE_ENTER_COMMENT: 'comments',
    AWARD_POINTS_TIPS: 'Best comments can get 1000 points 1000=10RMB',
    NO_SHOW_ANONYMOUS_AVATAR: 'Anonymous comments will not show your logo and name',
    LOCATION: 'location',
    FACILITY: 'facility',
    SERVICE: 'service',
    HEALTH: 'clean',
    LANGUAGE_SELECT: 'language',
    LIMIT_COMMENT_TXT: 'Review must have 5~2000 characters',
    COLLECTED_SUCCEED: 'Collection successful！',
    CANCEL_COLLECT: 'Collection canceled！',
  },
  WX_SHARED: {
    DETAIL_TITLE: '|Hotel Reservation',
    COMMON_TITLE: 'Search Hotel|Tens of thousands of hotels in Asia online for reservation',
    SUB_TITLE: 'BaiGolf provides you with online reservation of Tens of thousands of hotels in Asia, all are at an affordable price and easy to book.',
  },
};



// WEBPACK FOOTER //
// ./src/lang/en_us.js